import script from "./HrInnerLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./HrInnerLoading.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
